import { useState } from 'react';
import { C } from '../../lib/tokens.js';
import { useViewport } from '../../lib/useViewport.js';

export function Tabs({ tabs, value, onChange, style: extra }) {
  const { isMobile } = useViewport();
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-end', borderBottom: `1px solid ${C.mercury}`, gap: 2,
      ...extra,
    }}>
      {tabs.map(tab => (
        <TabButton key={tab.id} active={tab.id === value} count={tab.count} icon={tab.icon} compact={isMobile}
          onClick={() => onChange?.(tab.id)}>
          {tab.label}
        </TabButton>
      ))}
    </div>
  );
}

function TabButton({ active, onClick, children, count, icon, compact }) {
  const [h, setH] = useState(false);
  return (
    <button type="button" onClick={onClick}
      onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{
        padding: compact ? '8px 6px' : '10px 14px', fontSize: 13, fontWeight: active ? 500 : 400,
        background: 'transparent', color: active ? C.deepsea : (h ? C.fg : C.iron),
        border: 'none', borderBottom: `2px solid ${active ? C.liquid : 'transparent'}`,
        cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
        flex: compact ? '1 1 0' : '0 0 auto', minWidth: 0,
        marginBottom: -1, fontFamily: 'Roboto, sans-serif',
      }}>
      {icon ? <span className="material-icons" style={{ fontSize: 16, flexShrink: 0 }}>{icon}</span> : null}
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{children}</span>
      {count != null ? (
        <span style={{
          background: active ? C.rowActive : C.platinum,
          color: active ? C.deepsea : C.iron,
          fontSize: 10, fontWeight: 500, padding: '1px 6px', borderRadius: 999, flexShrink: 0,
        }}>{count}</span>
      ) : null}
    </button>
  );
}
